let instance = null

export const emojiDictionary = [
  // order is important, for example '>:(' needs to be before ':('
  { key: ':)', value: '😊' },
  { key: ';)', value: '😉' },
  { key: ':x', value: '😘' },
  { key: ':]', value: '😃' },
  { key: ':D', value: '😄' },
  { key: ':P', value: '😋' },
  { key: ';P', value: '😜' },
  { key: '8)', value: '😎' },
  { key: ':|', value: '😐' },
  { key: '>:(', value: '😠' },
  { key: ':(', value: '🙁' },
  { key: ':\'(', value: '😢' },
  { key: ':/', value: '🤒' },
  { key: ':O', value: '😲' },
  { key: ':o', value: '😯' },
  { key: 'xD', value: '😂' },
  { key: 'XD', value: '😂' },
  { key: '<3', value: '💗' },
  { key: ':*', value: '😗' },
  { key: ':thumbs-up', value: '👍' },
  { key: ':thumbs-down', value: '👎' }
]

class MessageService {
  parseInputText (text) {
    let modified = false
    let words = text.split(' ')
    words = words.map(word => {
      const parsedWord = this.parseInputWord(word)

      if (parsedWord.modified) {
        modified = true
      }

      return parsedWord.text
    })
    return {
      modified,
      text: words.join(" ")
    }
  }
  parseOutputText (text) {
    let modified = false
    let words = text.split(' ')
    words = words.map(word => {
      const parsedWord = this.parseOutputWord(word)

      if (parsedWord.modified) {
        modified = true
      }

      return parsedWord.text
    })
    return {
      modified,
      text: words.join(" ")
    }
  }

  parseInputWord (text) {
    let currentText = text
    let modified = false

    if (!currentText.startsWith('http'))

    emojiDictionary.map(emoji => {
      const { key, value } = emoji
      const index = text.indexOf(key)
      if (index !== -1) {
        modified = true
        currentText = currentText.split(key).join(value)
      }
    })
    return {
      modified,
      text: currentText
    }
  }

  parseOutputWord (text) {
    let currentText = text
    let modified = false

    if (currentText.startsWith('http')) {
      modified = true
      currentText = '<a href="'+currentText+'" target="_blank">'+currentText+'</a>';
    }

    return {
      modified,
      text: currentText
    }
  }
}

export const messageServiceInstance = () => {
  return instance || (instance = new MessageService())
}
